import { createContext, useContext, useEffect, useState } from "react";

const LanguageContext = createContext(null);
const STORAGE_KEY = "dr_lang";

// İlk ziyarette dili otomatik algıla: tarayıcı dili veya saat dilimi Türkiye'yi
// işaret ediyorsa Türkçe, aksi hâlde İngilizce başlat.
function detectLang() {
  try {
    const langs = navigator.languages?.length ? navigator.languages : [navigator.language];
    if (langs.some((l) => (l || "").toLowerCase().startsWith("tr"))) return "tr";
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone || "";
    if (tz === "Europe/Istanbul" || tz === "Asia/Istanbul") return "tr";
    return "en";
  } catch {
    return "tr";
  }
}

export function LanguageProvider({ children }) {
  const [autoDetected, setAutoDetected] = useState(false);
  const [lang, setLangState] = useState(() => {
    if (typeof window === "undefined") return "tr";
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved === "en" || saved === "tr") return saved;
    return detectLang();
  });

  useEffect(() => {
    if (!localStorage.getItem(STORAGE_KEY)) setAutoDetected(true);
  }, []);

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  const setLang = (next) => {
    localStorage.setItem(STORAGE_KEY, next);
    setAutoDetected(false);
    setLangState(next);
  };

  return (
    <LanguageContext.Provider value={{ lang, setLang, isEn: lang === "en", autoDetected }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLang() {
  const ctx = useContext(LanguageContext);
  if (!ctx) return { lang: "tr", setLang: () => {}, isEn: false, autoDetected: false };
  return ctx;
}
